type Cue = 'focus' | 'whoosh' | 'thud'
export function createRotationAudio() {
  let context: AudioContext | null = null
  let gain: GainNode | null = null
  let enabled = false
  const buffers = new Map<Cue, AudioBuffer>()
  const sources = new Map<AudioBufferSourceNode, Cue>()
  const stop = (cue?: Cue) => {
    for (const [source, kind] of sources)
      if (!cue || kind === cue) {
        source.stop()
        sources.delete(source)
      }
  }
  return {
    async toggle(): Promise<boolean> {
      try {
        if (enabled) {
          enabled = false
          if (gain) gain.gain.value = 0
          stop()
          return false
        }
        context ??= new AudioContext()
        await context.resume()
        if (!gain) {
          gain = context.createGain()
          gain.connect(context.destination)
        }
        const audioContext = context
        await Promise.all(
          (['focus', 'whoosh', 'thud'] as Cue[]).map(async (cue) => {
            if (buffers.has(cue)) return
            const response = await fetch(`/audio/rotation/${cue}.mp3`)
            if (!response.ok) throw new Error('Sound unavailable')
            buffers.set(
              cue,
              await audioContext.decodeAudioData(await response.arrayBuffer()),
            )
          }),
        )
        gain.gain.value = 0.2
        enabled = true
        return true
      } catch {
        enabled = false
        return false
      }
    },
    play(cue: Cue, delay = 0) {
      if (!enabled || !context || !gain || !buffers.has(cue)) return
      if (cue === 'focus') stop('focus')
      const source = context.createBufferSource()
      source.buffer = buffers.get(cue)!
      source.connect(gain)
      sources.set(source, cue)
      source.onended = () => sources.delete(source)
      source.start(context.currentTime + delay)
    },
    cancelThud() {
      stop('thud')
    },
    dispose() {
      enabled = false
      stop()
      void context?.close().catch(() => {})
    },
  }
}
